export default "__VITE_ASSET__807dda5e__"